import { render, staticRenderFns } from "./ButtonBulkReplaceContentHeader.vue?vue&type=template&id=ecc13396"
import script from "./ButtonBulkReplaceContentHeader.vue?vue&type=script&lang=ts"
export * from "./ButtonBulkReplaceContentHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports